import { Component, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MenuService } from '../../../menu.service';
import { UserInformationService } from '../../../user-information.service';
import { MenuCommand } from '../../../../shared/models/menu-command';

@Component({
    selector: 'ldw-user-bottom-sheet',
    templateUrl: './user-bottom-sheet.component.html',
    styleUrls: ['./user-bottom-sheet.component.css'],
    standalone: false
})
export class UserBottomSheetComponent {
  menuService = inject(MenuService);
  private _bottomSheetRef = inject<MatBottomSheetRef<UserBottomSheetComponent>>(MatBottomSheetRef);
  private userInformationService = inject(UserInformationService);

  userName = '';
  cmdSettings!: MenuCommand;
  cmdSignOff!: MenuCommand;

  constructor() {
    const menuService = this.menuService;

    const userInfo = this.userInformationService.userInformation;
    if (!userInfo.isEmpty) {
      this.userName = userInfo.DisplayName;
    }

    this.cmdSettings = menuService.cmdSettings;
    this.cmdSignOff = menuService.cmdSignOff;
  }

  get cmdCustomHelp(): MenuCommand {
    return this.menuService.cmdCustomHelp;
  }
  get cmdDefaultHelp(): MenuCommand {
    return this.menuService.cmdDefaultHelp;
  }

  hasDefaultHelp(): boolean {
    return this.cmdDefaultHelp != null;
  }

  hasCustomHelp(): boolean {
    return this.cmdCustomHelp != null;
  }

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  openHelp(cmd: MenuCommand): void {
    this._bottomSheetRef.dismiss();
    console.log(cmd);
    window.open(cmd.route, '_blank');
  }
}
